import { RUNNING_ENVIRONMENT } from '../../../config/env';
import { eEnv } from '../../../constants';

const msalAuthDevScopes = [
  'https://estiworlddev.onmicrosoft.com/estiworld-api/estiworld.api',
];
const msalAuthTestScopes = [
  'https://estiworldtest2.onmicrosoft.com/42e976d8-f477-42ed-a138-57b9adef20c1/estiworld.api',
];
const msalAuthStageScopes = [
  'https://estiworldstage.onmicrosoft.com/5540111b-8889-4c4c-b17c-1af65913a1ce/estiworld.api',
];
const msalAuthProdScopes = [
  'https://estimationworld.onmicrosoft.com/aac835ea-f159-4c91-a2fb-cdf18279cdc4/estiworld.api',
];

const getMsalAuthScopes = (): string[] => {
  switch (RUNNING_ENVIRONMENT) {
    case eEnv.LOCAL:
    case eEnv.DEV:
      return msalAuthDevScopes;
    case eEnv.TEST:
      return msalAuthTestScopes;
    case eEnv.STAGE:
      return msalAuthStageScopes;
    case eEnv.PROD:
      return msalAuthProdScopes;
    default:
      throw new Error(`Unknown environment: ${RUNNING_ENVIRONMENT}`);
  }
};

export const msalAuthScopes: string[] = getMsalAuthScopes();
